import React, { useState } from "react";
import { Box, Tabs, Tab, Card, CardContent } from "@mui/material";
import GoogleCredentials from "../Credentials/GoogleCredentials";
import PlentyCredentials from "../Credentials/PlentyCredentials";
import OpenAICredentials from "../Credentials/OpenAICredentials";
import SellerlogicCredentials from "../Credentials/SellerlogicCredentials";

const TabPanel = ({ children, value, index, ...other }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`credentials-tabpanel-${index}`}
    aria-labelledby={`credentials-tab-${index}`}
    {...other}
  >
    {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
  </div>
);

const CredentialsTab = () => {
  const [credentials, setCredentials] = useState(0);

  const handleCredentialsChange = (event, newValue) => {
    setCredentials(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Card>
        <CardContent>
          <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
            <Tabs
              value={credentials}
              onChange={handleCredentialsChange}
              aria-label="credentials tabs"
            >
              <Tab label="Google Credentials" />
              <Tab label="Plenty Credentials" />
              <Tab label="Sellerlogic Credentials" />
              <Tab label="OpenAI Credentials" />
            </Tabs>
          </Box>

          {/* Google Credentials Tab */}
          <TabPanel value={credentials} index={0}>
            <GoogleCredentials />
          </TabPanel>

          {/* Plenty Credentials Tab */}
          <TabPanel value={credentials} index={1}>
            <PlentyCredentials />
          </TabPanel>

          {/* Sellerlogic Credentials Tab */}
          <TabPanel value={credentials} index={2}>
            <SellerlogicCredentials />
          </TabPanel>

          {/* OpenAI Credentials Tab */}
          <TabPanel value={credentials} index={3}>
            <OpenAICredentials />
          </TabPanel>
        </CardContent>
      </Card>
    </Box>
  );
};

export default CredentialsTab;
